export default __webpack_public_path__ + "static/media/logo-nooio-black.9d6e28e2.svg";